import React from 'react';
import { ABOUT_TEXT } from '../constants';
import videoSrc from '../assets/videos/football-video-1.mp4';
import { motion } from "framer-motion";

const About = () => {
  return (
    <div className="border-b border-opacity-20 border-gray-400 dark:border-gray-600 pb-16 bg-surface-light dark:bg-surface-dark">
      <h2 className="my-20 text-center text-4xl text-text-primary-light dark:text-text-primary-dark">
        About <span className="text-text-secondary-light dark:text-text-secondary-dark">Project</span>
      </h2>
      <div className="flex flex-wrap lg:flex-nowrap container mx-auto px-8">
        <div className="w-full lg:w-1/2 lg:p-8">
          <div className="flex justify-center items-center">
            <motion.video
              whileInView={{ opacity: 1, x: 0 }}
              initial={{ opacity: 0, x: -100 }}
              transition={{ duration: 1 }}
              className="w-full rounded-lg shadow-xl"
              src={videoSrc}
              autoPlay
              loop
              muted
            />
          </div>
        </div>
        <div className="w-full lg:w-1/2">
          <div className="flex justify-center lg:justify-start items-center">
            <motion.p
              whileInView={{ opacity: 1, x: 0 }}
              initial={{ opacity: 0, x: 100 }}
              transition={{ duration: 1 }}
              className="my-2 max-w-xl py-6 text-text-secondary-light dark:text-text-secondary-dark text-lg leading-relaxed"
            >
              {ABOUT_TEXT}
            </motion.p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;